<div xpoDialog>
  <h1 mat-dialog-title>
    Renew
    <xpo-dialog-close-button></xpo-dialog-close-button>
  </h1>
  <div mat-dialog-content class="dialogContentContainer">
    <div class="form-container">
      <mat-form-field floatLabel="always">
        <mat-label>Effective Date</mat-label>
        <input matInput required [matDatepicker]="effDatePicker" [(ngModel)]="newEffectiveDate" #effModel="ngModel"
          (ngModelChange)="onEffectiveDateChange($event, effModel)" />
        <mat-error *ngIf="!newEffectiveDate">Invalid Date</mat-error>
        <mat-error *ngIf="!effDateIsValid && newEffectiveDate">{{ effDateErrorMsg }}</mat-error>
        <mat-datepicker-toggle matSuffix [for]="effDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #effDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>Renegotiate Date</mat-label>
        <input matInput required [matDatepicker]="renegDatePicker" [(ngModel)]="newRenegDate" #renegModel="ngModel"
          (ngModelChange)="onRenegDateChange($event, renegModel)" />
        <mat-error *ngIf="!newRenegDate">Invalid Date</mat-error>
        <mat-error *ngIf="!renegDateIsValid && newRenegDate">{{ renegDateErrorMsg }}</mat-error>

        <mat-datepicker-toggle matSuffix [for]="renegDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #renegDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>Expiry Date</mat-label>
        <input matInput [matDatepicker]="expiryDatePicker" [(ngModel)]="newExpiryDate" #expModel="ngModel"
          (ngModelChange)="onExpiryDateChange($event, expModel)" />
        <mat-error *ngIf="!expDateIsValid">{{ expDateErrorMsg }}</mat-error>
        <mat-datepicker-toggle matSuffix [for]="expiryDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #expiryDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <xpo-button-group>
      <button mat-flat-button xpoLargeButton xpoButton [disabled]="isSaveDisabled()"
        [mat-dialog-close]="getRenewData()">
        Save
      </button>
    </xpo-button-group>
  </div>
</div>
